import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArLB: CultureInfo = {
  name: 'ar-LB',
  displayName: 'Arabic (Lebanon)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-LB',
  parent: CultureInfoAr
};
